import { useTheme } from 'styled-components'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import { statisticOrientations } from '@/common/components/Statistic/constants'

import RefundMethodsHalfPieChart from './RefundMethodsHalfPieChart/RefundMethodsHalfPieChart'
import RefundMethodsListSkeleton from './RefundMethodsListSkeleton/RefundMethodsListSkeleton'
import RefundMethodsPieChart from './RefundMethodsPieChart/RefundMethodsPieChart'
import RefundMethodsTable from './RefundMethodsTable/RefundMethodsTable'
import RefundMethodsTotals from './RefundMethodsTotals/RefundMethodsTotals'
import { getRefundMethodsData } from './helpers'
import * as Styles from './styles'

const RefundMethodsList = ({
  loading,
  numOfAvailableRefundMethods,
  totalRefunds,
  totalAmount,
  refundMethods,
  currency,
  refundMethodsFilters,
  onChangeRefundMethodsFilters,
}) => {
  const theme = useTheme()

  const handleSort = value => {
    const filterValueWithOrdering = refundMethodsFilters?.ordering === value ? `-${value}` : value
    onChangeRefundMethodsFilters({ ...refundMethodsFilters, ordering: filterValueWithOrdering })
  }

  if (loading) return <RefundMethodsListSkeleton />
  if (!refundMethods?.length) return <NoResultsFound />

  return (
    <Styles.MainContainer>
      {numOfAvailableRefundMethods === 1 && (
        <Styles.TotalsContainer>
          <RefundMethodsTotals
            totalRefunds={totalRefunds}
            totalAmount={totalAmount}
            currency={currency}
            orientation={statisticOrientations.vertical}
          />
        </Styles.TotalsContainer>
      )}
      {numOfAvailableRefundMethods === 2 && (
        <Styles.HalfPieColumn>
          <RefundMethodsHalfPieChart data={getRefundMethodsData(refundMethods, theme)} />
        </Styles.HalfPieColumn>
      )}
      {numOfAvailableRefundMethods > 2 && (
        <Styles.ChartColumn>
          <RefundMethodsPieChart data={getRefundMethodsData(refundMethods, theme)} />
          <RefundMethodsTotals
            totalRefunds={totalRefunds}
            totalAmount={totalAmount}
            currency={currency}
            orientation={statisticOrientations.horizontal}
          />
        </Styles.ChartColumn>
      )}
      <RefundMethodsTable
        refundMethods={getRefundMethodsData(refundMethods, theme)}
        totalRefunds={totalRefunds}
        totalAmount={totalAmount}
        showTotal={numOfAvailableRefundMethods === 2}
        currency={currency}
        onSort={handleSort}
        orderBy={refundMethodsFilters?.ordering}
      />
    </Styles.MainContainer>
  )
}

export default RefundMethodsList
